import { useState, useEffect, useContext } from 'react';
import { AppContext } from "../../utils/ContextProvider";
import { Link, useLocation, useNavigate } from 'react-router-dom';
import './style.css'
import API from '../../utils/API';
import Swal from 'sweetalert2';
import AssetInfo from '../../components/AssetInfo';
import AssetMaintenance from '../../components/AssetMaintenance';
import moment from 'moment';
import GlobalFuncs from '../../utils/GlobalFuncs';
import AssetAlerts from '../../components/AssetAlerts';
import AssetActuator from '../../components/AssetActuator';
import DeviceInfo from '../../components/DeviceInfo';

const Circuit = () => {

    const location = useLocation();
    const [getPutPost, setGetPutPost] = useState()

    const [channel, setChannel] = useState(null)
    const [tab, setTab] = useState("1")
    const [alerts, setAlerts] = useState()
    const [circuit, setCircuit] = useState()
    const [devicePhotos, setDevicePhotos] = useState(null)
    const [equipmentRuntime, setEquipmentRuntime] = useState([])
    const [maintenanceData, setMaintenanceData] = useState(null)
    const [devicedata, setDeviceData] = useState(null)
    const [maintenanceGroups, setMaintenanceGroups] = useState(null)
    const [alertGroups, setAlertGroups] = useState(null)
    const [deviceOnly, setDeviceOnly] = useState(false)
    const [error, setError] = useState(null)
    const [loading, setLoading] = useState({ "1": true, "2": true, "3": true, "4": true, "5": true })
    const context = useContext(AppContext)
    const navigate = useNavigate();
    const queryParams = new URLSearchParams(location.search)
    const [relays, setRelays] = useState({})
    const [actuatorData, setActuatorData] = useState({
        device_id: "",

    })

    useEffect(() => {
        if (['put'].includes(getPutPost)) return
        if (queryParams.size !== 0) {
            let tempDevice = queryParams.get('device_id')
            if (tempDevice) {
                const cancelToken = API.cancelToken();
                getDevice(cancelToken, tempDevice)
                setTab("5")
                setDeviceOnly(true)
            } else {
                let tempChannel = queryParams.get('channel_id')
                let tempTab = queryParams.get('tab')
                if (!tempChannel) navigate('/map')
                setChannel(tempChannel)
                setGetPutPost('get')
                setTab(tempTab)
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [queryParams, location])

    const getDevice = (cancelToken, id) => {
        API.getDevice(cancelToken, id).then(async devRes => {
            setLoading(e => ({ ...e, "5": false }))
            setDeviceData(devRes.data)
        }).catch(err => {
            setLoading(e => ({ ...e, "5": false }))
            console.log(err)
            if (err.message === 'cancelling') return
            let message = 'Please try again later.'
            if (err.response && err.response.data && err.response.data.includes('error')) {
                message = err.response.data.error
            }
            Swal.fire({
                title: 'Error.',
                text: message,
                icon: 'warning',
                confirmButtonText: 'Ok',
                confirmButtonColor: '#007b4e',
            });
        })
    }

    useEffect(() => {
        if (!context.getUserInfo || !channel) return
        const cancelToken = API.cancelToken();

        if (getPutPost === 'get') {
            API.getCircuit(cancelToken, channel).then(res => {
                setCircuit(res.data)
                if (!res.data.virtual && res.data.utility_type === 'Electric') {
                    API.getMaintenanceGroupByCircuit(cancelToken, res.data.id).then(async maintRes => {
                        let date = moment('2022-01-01')
                        for (const item of maintRes.data) {
                            const logs = item.logs;
                            if (!logs) continue;
                            for (const log of logs) {

                                const timebase = log.timebase;

                                if (timebase === null || timebase === "runtime") {
                                    const tempDate = moment(log.completed_date);
                                    // Track earliest date
                                    if (date === null || tempDate.isBefore(date)) {
                                        date = tempDate.clone()
                                    }
                                }
                            }
                        }
                        if (date) {
                            try {
                                let runtime = await API.getCircuitRuntime(cancelToken, date.format('YYYY-MM-DD'), moment().format('YYYY-MM-DD'), res.data.id)
                                setEquipmentRuntime({ [res.data.id]: runtime.data.series })
                                setMaintenanceData(maintRes.data)
                            } catch (err) {
                                console.log(err)
                                if (err.message === 'cancelling') return
                                let message = 'Please try again later.'
                                if (err.response && err.response.data) {
                                    message = err.response.data
                                }
                                Swal.fire({
                                    title: 'Error.',
                                    text: message,
                                    icon: 'warning',
                                    confirmButtonText: 'Ok',
                                    confirmButtonColor: '#007b4e',
                                });
                            }
                        }
                        setLoading(e => ({ ...e, "2": false }))
                    }).catch(err => {
                        setLoading(e => ({ ...e, "2": false }))
                        console.log(err)
                        if (err.message === 'cancelling') return
                        let message = 'Please try again later.'
                        if (err.response && err.response.data && err.response.data.includes('error')) {
                            message = err.response.data.error
                        }
                        Swal.fire({
                            title: 'Error.',
                            text: message,
                            icon: 'warning',
                            confirmButtonText: 'Ok',
                            confirmButtonColor: '#007b4e',
                        });
                    })
                } else {
                    setEquipmentRuntime({})
                    setMaintenanceData(false)
                }
                if (context.getUserInfo.access_buildings_and_operators_list) {
                    getDevice(cancelToken, res.data.device_id)
                }

                API.getDevicePictures(cancelToken, res.data.id).then(res => {
                    setLoading(e => ({ ...e, "1": false }))
                    setDevicePhotos(res.data)
                }).catch(err => {
                    setLoading(e => ({ ...e, "1": false }))
                    console.log(err)
                    if (err.message === 'cancelling') return
                    let message = 'Please try again later.'
                    if (err.response && err.response.data && err.response.data.includes('error')) {
                        message = err.response.data.error
                    }
                    Swal.fire({
                        title: 'Error.',
                        text: message,
                        icon: 'warning',
                        confirmButtonText: 'Ok',
                        confirmButtonColor: '#007b4e',
                    });
                })
                if (context.getUserInfo && context.getUserInfo.view_alerts) {
                    API.getAlertGroupByCircuit(cancelToken, res.data.id).then(res => {
                        setLoading(e => ({ ...e, "3": false }))
                        setAlerts(res.data)
                    }).catch(err => {
                        setLoading(e => ({ ...e, "3": false }))
                        console.log(err)
                        if (err.message === 'cancelling') return
                        let message = 'Please try again later.'
                        if (err.response && err.response.data && err.response.data.includes('error')) {
                            message = err.response.data.error
                        }
                        Swal.fire({
                            title: 'Error.',
                            text: message,
                            icon: 'warning',
                            confirmButtonText: 'Ok',
                            confirmButtonColor: '#007b4e',
                        });
                    })
                }
                if (res.data.actuator) {
                    API.getActuator(cancelToken, res.data.actuator.id).then(res => {
                        setLoading(e => ({ ...e, "4": false }))
                        setActuatorData(res.data)
                        let portsDict = { 0: "input", 1: "output" }
                        let positionDict = { 0: "closed", 1: "half", 2: "partial", 3: "open" }
                        const chanPort = res.data.ports.reduce((acc, item) => {
                            acc[item.id] = item;
                            return acc;
                        }, {});
                        const tempRelays = res.data.positions.reduce((acc, item) => {
                            if (item.type === 1) {
                                acc[`${positionDict[item.actuator_status]}_${portsDict[item.type]}_${chanPort[item.actuator_channel_id].port_number}`] = item;
                            }
                            return acc;
                        }, {});
                        setRelays(tempRelays)
                    }).catch(err => {
                        setLoading(e => ({ ...e, "4": false }))
                        console.log(err)
                        if (err.message === 'cancelling') return
                        let message = 'Please try again later.'
                        if (err.response && err.response.data && err.response.data.includes('error')) {
                            message = err.response.data.error
                        }
                        Swal.fire({
                            title: 'Error.',
                            text: message,
                            icon: 'warning',
                            confirmButtonText: 'Ok',
                            confirmButtonColor: '#007b4e'
                        });

                    })
                }
            }).catch(err => {
                setLoading({ "1": false, "2": false, "3": false, "4": false, "5": false })
                console.log(err)
                if (err.message === 'cancelling') return
                let message = 'Please try again later.'
                if (err.response && err.response.data && err.response.data.includes('error')) {
                    message = err.response.data.error
                }
                Swal.fire({
                    title: 'Error.',
                    text: message,
                    icon: 'warning',
                    confirmButtonText: 'Ok',
                    confirmButtonColor: '#007b4e',
                });
            })

        }

        return () => {
            API.cancel(cancelToken);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [getPutPost, channel, context.getUserInfo])


    useEffect(() => {
        if (equipmentRuntime.length === 0 || !maintenanceData) return
        updateMaintenanceNumbers(maintenanceData, equipmentRuntime)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [equipmentRuntime, maintenanceData])

    useEffect(() => {
        if (!alerts) return
        updateAlertNumbers(alerts)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [alerts])

    useEffect(() => {
        if (!circuit || !context) return
        context.setBuilding(circuit.building_id)
    }, [circuit, context])

    const updateMaintenanceNumbers = async (tempGroups) => {
        if (equipmentRuntime.length === 0) return
        let final = GlobalFuncs.getCalculatedMaintenanceValues(context, tempGroups, equipmentRuntime)
        setMaintenanceGroups(final)
    }

    const updateAlertNumbers = async (tempGroups) => {
        let final = GlobalFuncs.getCalculatedAlertValues(tempGroups, context)
        setAlertGroups(final)
    }

    return (
        <div>
            {
                !deviceOnly &&
                <div className="laptop:p-[24px] tablet:p-[16px] mobile:p-[12px] flex flex-nowrap justify-between items-center rounded-md bg-[#FFF] shadow-md" >
                    <div className='flex flex-nowrap justify-between items-center gap-6 text-base font-bold w-full'>
                        <div className="">
                            {circuit && <h2 className="text-[#332D41] text-[20px] font-bold">{circuit.channel_name}</h2>}
                        </div>
                        <div className="flex flex-norwap justify-end items-center">
                            <Link to={`/circuit?channel_id=${channel}&tab=1`} className={`${tab === "1" ? "active-reports-tab" : ""} mr-6`}>Asset Info</Link>
                            {context.getUserInfo && context.getUserInfo.access_buildings_and_operators_list && <Link to={`/circuit?channel_id=${channel}&tab=5`} className={`${tab === "5" ? "active-reports-tab" : ""} mr-6`}>Device Info</Link>}
                            <Link to={`/circuit?channel_id=${channel}&tab=2`} className={`${tab === "2" ? "active-reports-tab" : ""} mr-6`}>Maintenance</Link>
                            {context.getUserInfo && context.getUserInfo.view_alerts && <Link to={`/circuit?channel_id=${channel}&tab=3`} className={`${tab === "3" ? "active-reports-tab" : ""} mr-6`}>Alerts</Link>}
                            {circuit?.actuator?.id && <Link to={`/circuit?channel_id=${channel}&tab=4`} className={`${tab === "4" ? "active-reports-tab" : ""}`}>Actuator</Link>}
                        </div>
                    </div>
                </div>
            }
            {tab === "1" &&
                <AssetInfo
                    circuit={circuit}
                    setCircuit={setCircuit}
                    devicePhotos={devicePhotos}
                    setDevicePhotos={setDevicePhotos}
                    getPutPost={getPutPost}
                    setGetPutPost={setGetPutPost}
                    loading={loading[tab]}
                    error={error}
                    setError={setError}
                    setLoading={setLoading}
                />
            }
            {tab === "5" &&
                <DeviceInfo
                    device={devicedata}
                    loading={loading[tab]}
                />
            }

            {tab === "2" &&
                <AssetMaintenance
                    circuit={circuit}
                    groups={maintenanceGroups}
                    setGroups={setMaintenanceGroups}
                    loading={loading[tab]}
                    updateNumbers={updateMaintenanceNumbers}
                    error={error}
                    setError={setError} />
            }

            {tab === "3" && context.getUserInfo && context.getUserInfo.view_alerts &&
                <AssetAlerts
                    circuit={circuit}
                    groups={alertGroups}
                    setGroups={setAlertGroups}
                    loading={loading[tab]}
                    updateNumbers={updateAlertNumbers}
                    error={error}
                    setError={setError} />
            }

            {tab === "4" && <AssetActuator
                actuator={actuatorData}
                relays={relays}
                loading={loading[tab]} />
            }
        </div>
    )
}


export default Circuit;